import type { CollapseProps } from "antd";

import Info from "./Info";
import NewsContentDetail from "./NewsContentDetail";

export const InputStyle = { 
	height: "40px",
	width: "100%",
	marginBottom: "10px",
};
export const labelStyle: React.CSSProperties = {
	padding: 0,
	fontWeight: "normal",
	width: "120px",
	fontSize: "15px",
};

export const panelStyle: React.CSSProperties = {
	border: "none",
};

export const EditEmployeeTransactionsConstants = {
	INFO: "Genel Bilgiler",
	CONTENT_DETAIL_TR: "Türkçe İçerik Detayı",
	CONTENT_DETAIL_EN: "İngilizce İçerik Detayı",
};

export const EmployeeItems: CollapseProps["items"] = [
	{
		key: "1",
		label: EditEmployeeTransactionsConstants.INFO,
		children: <Info />,
		style: panelStyle,
	},
	{
		key: "2",
		label: EditEmployeeTransactionsConstants.CONTENT_DETAIL_TR,
		children: <NewsContentDetail isEnContent={false} />,
		style: panelStyle,
	},
	{
		key: "3",
		label: EditEmployeeTransactionsConstants.CONTENT_DETAIL_EN,
		children: <NewsContentDetail isEnContent={true} />,
		style: panelStyle,
	}			
];
